import React from 'react';
import { ShieldCheckIcon } from '../SiteProofLogo';

/**
 * LoadingSpinner — shared loading indicator.
 *
 * Props:
 *   size:    'sm' | 'md' | 'lg' | 'xl'   (default: 'md')
 *   fullPage: boolean — centres spinner in full viewport (default: false)
 *   label:   string — optional text below spinner
 *   className: extra classes on the spinner element
 */
const sizeMap = {
  sm: 20,
  md: 32,
  lg: 48,
  xl: 64,
};

const LoadingSpinner = ({ size = 'md', fullPage = false, label = '', className = '' }) => {
  const iconSize = sizeMap?.[size] || sizeMap?.md;

  const spinner = (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <div className="animate-pulse">
        <ShieldCheckIcon size={iconSize} />
      </div>
      {label && <p className="text-sm text-muted-foreground">{label}</p>}
    </div>
  );

  if (fullPage) {
    return (
      <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] pt-16">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
